export default {"src":"/images/1.jpg","width":719,"height":1000,"aspectRatio":0.719};